// hook which trigger the oauth flow for a given app and auth provider
import { getDomainConfig } from '@/config/domainConfig';

const BASE_URL = getDomainConfig().apiBaseUrl;

// Utility function to open OAuth window
export const openOAuthWindow = (app_name: string, auth_name: string = "default") => {
  const url = `${BASE_URL}/auth/oauth/${app_name}/${auth_name}?token_dispatch_mode=browser`;
  window.open(url, "", "width=800,height=600");
};

const useConnectToOauthApps = (app_name: string, auth_name: string) => {
  return () => openOAuthWindow(app_name, auth_name);
};

export default useConnectToOauthApps;